import {CommandBase} from '@shared/commands/command-base';
import {CountryModel} from '@shared/models/country.model';
import {EntityChartConfig} from '../entity-chart-config';
import {Guid} from 'guid-typescript';

export class EntityImportCommand extends CommandBase {
  public publicationId: string;
  public fileType: string;

  constructor(public fileId: string, public replaceExistingSelection: boolean) {
    super(EntityChartConfig.EntityChartImportApi);
    this.publicationId = Guid.create().toString();
    this.fileType = 'Excel';
    this.projectId = '[PROJECT_ID]';
  }
}

export class EntitySettingsAddEntityCommand extends CommandBase {
  constructor(public countries: CountryModel[]) {
    super(EntityChartConfig.EntityChartAddEntityApi);
    this.projectId = '[PROJECT_ID]';
  }
}

export class ResetEntitiesFromProjectSettingsCommand extends CommandBase {
  constructor() {
    super(EntityChartConfig.ResetEntitiesFromProjectSettingsApi);
    this.projectId = '[PROJECT_ID]';
  }
}

export class EntitySettingsDeleteEntityCommand extends CommandBase {
  constructor(public entityIds: string[]) {
    super(EntityChartConfig.EntityChartDeleteEntityApi);
    this.projectId = '[PROJECT_ID]';
  }
}

export class PostProjectTopics extends CommandBase {
  constructor(public Topics: any[]) {
    super(EntityChartConfig.PostProjectTopicsApi);
    this.projectId = '[PROJECT_ID]';
  }
}
